
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://34286500fe7e28b4a4313815f0ba44d5@o4510221791920128.ingest.de.sentry.io/4510221793755216",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(<App />);
